export enum LayoutSize {
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
}

export type LayoutBreakpointsConfig = Record<LayoutSize, number>;
